import { useSelector } from "react-redux";
import { globalConfig } from "../constants";

const SupportMailsSection = () => {
  const {affiliate} = useSelector(state=>state.language?.activelang);

  return (
    <section className="about-blocks-section tc-block">
      <div className="terms-and-conditions-section grid">
        <div className="col-12 lg:col-4 md:col-4">
          <h3>{affiliate?.AFFNL0035}</h3>
          <p>
            {affiliate?.AFFNL0049} <br />
            {affiliate?.AFFNL0050}
          </p>
          <a
            href={`mailto:${globalConfig.supportEmail}`}
            className="email-link"
          >
            {globalConfig.supportEmail}
          </a>
        </div>
        <div className="col-12 lg:col-4 md:col-4">
          <h3>{affiliate?.AFFNL0034}</h3>
          <p>
          {affiliate?.AFFNL0049} <br />
            {affiliate?.AFFNL0050}
          </p>
          <a
            href={`mailto:${globalConfig.salesEmail}`}
            className="email-link"
          >
            {globalConfig.salesEmail}
          </a>
        </div>
        <div className="col-12 lg:col-4 md:col-4">
          <h3>{affiliate?.AFFNL0052}</h3>
          <p>
            {affiliate?.AFFNL0060}-{affiliate?.AFFNL0054}{" "}
            {affiliate?.AFFNL0053} 8am {affiliate?.AFFNL0059}{" "}
            <br />
            5pm.
          </p>
            <a
            href={`tel:${globalConfig.phoneNumber}`}
            className="email-link"
          >
            {globalConfig.phoneNumber}
          </a>
        </div>
      </div>
    </section>
  );
};

export default SupportMailsSection;
